import { Typography } from '@src/components/Typography/Typography';
import './Snippet.css';

export interface SnippetProps {
  children: string;
}

export function Snippet({ children }: SnippetProps) {
  return (
    <Typography as="pre" role="meta/mono" className="snippet">
      <code>{children}</code>
    </Typography>
  );
}
